import DefaultLayout from '../../layout/DefaultLayout';
import BreadcrumbTwo from '../../components/Breadcrumbs/BreadcrumbTwo';

import CashStatusCard from '../../components/CashOpening/CashStatusCard';
import CashOpeningForm from '../../components/CashOpening/CashOpeningForm';
import CashOpeningDenominationSheet from '../../components/CashOpening/CashOpeningDenominationSheet';
import CashOpeningActions from '../../components/CashOpening/CashOpeningActions';

import { useCashSession } from '../../hooks/cash/useCashSession';

const CashOpeningPage: React.FC = () => {
  const { isCountingCash } = useCashSession();

  return (
    <DefaultLayout>
      <BreadcrumbTwo />

      <div className="grid grid-cols-1 gap-6 xl:grid-cols-3">
        <div className="space-y-6 xl:col-span-2">
          <CashOpeningForm />

          {isCountingCash && (
            <CashOpeningDenominationSheet />
          )}

          <CashOpeningActions />
        </div>

        <div className="xl:col-span-1">
          <div className="sticky top-24">
            <CashStatusCard />
          </div>
        </div>
      </div>
    </DefaultLayout>
  );
};

export default CashOpeningPage;